import React from 'react';

export interface DescriptionListItem {
  key: string;
  value: React.ReactNode;
}

export interface DescriptionListProps {
  items: DescriptionListItem[];
  column?: boolean;
  className?: string;
}

/**
 * KERN DescriptionList Component
 *
 * Usage:
 * <DescriptionList
 *   items={[
 *     { key: 'Name', value: 'Kim Musterperson' },
 *     { key: 'E-Mail', value: 'kim@example.com' }
 *   ]}
 * />
 */
export function DescriptionList({ items, column = false, className = '' }: DescriptionListProps) {
  const classes = ['kern-description-list', column && 'kern-description-list--col', className]
    .filter(Boolean)
    .join(' ');

  return (
    <dl className={classes}>
      {items.map((item) => (
        <div key={item.key} className="kern-description-list-item">
          <dt className="kern-description-list-item__key">{item.key}</dt>
          <dd className="kern-description-list-item__value">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

export default DescriptionList;
